import { type ChangeEvent, useCallback } from 'react'

import { TextField } from '@/components/ui/text-field'
import { SettingsOption } from '@/modules/creator-settings/ui/SettingsOption.tsx'
import { useDebouncedProperty } from '@/utils/useDebouncedProperty'

interface PromotionCostsControllerProps {
  promotionCost: number | undefined
  isFetching: boolean
  updatePromotionCost: (newPromotionCost: number | undefined) => void
}

export const PromotionCostsController = ({
  promotionCost,
  isFetching,
  updatePromotionCost,
}: PromotionCostsControllerProps) => {
  const [value, set] = useDebouncedProperty<number | undefined>(
    promotionCost || 0,
    updatePromotionCost,
  )

  const handleChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      const inputValue = event.target.value

      set(inputValue === '' ? undefined : Number(inputValue))
    },
    [set],
  )

  return (
    <SettingsOption
      title="Promotion Costs"
      description="Input the promotion costs to calculate your profit & return of invest"
      mobileVertical
      biggerTitle
    >
      {isFetching ? (
        <TextField
          type="number"
          showSuffixSeparator
          defaultValue={0}
          prefix={<span className="text-secondary-300">$</span>}
          disabled
        />
      ) : (
        <TextField
          type="number"
          showSuffixSeparator
          value={value}
          prefix={<span className="text-secondary-300">$</span>}
          onChange={handleChange}
        />
      )}
    </SettingsOption>
  )
}
